import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import {Page, Text, View, Document, StyleSheet} from "@react-pdf/renderer";
//import {ToWords} from 'to-words';

const styles = StyleSheet.create({
    page: {
      marginBottom:'20px'
    },
    section: {
      fontSize:10
    }
});
const Awlblank = (props) => {

    const history = useHistory();
    const [po,setpo] = useState(null);
    useEffect(() => {
        setpo(history.location.state.po);
      },[props.po, history.location.state.po]);

    // const formatDate = (dt) => {
    //     let cdt = new Date(dt);
    //     let month = cdt.getMonth() + 1;
    //     let day = cdt.getDate();
    //     if (month < 10) {
    //         month = '0' + month;
    //     }
    //     if (day < 10) {
    //         day = '0' + day;
    //     }
    //     return day+"-"+month+"-"+cdt.getFullYear() ;
    //   };
    let pdfDoc = null;

    if (po) { 
        //const toWords = new ToWords();
        const marks = new Array(po.noofcopies).fill(0);
        pdfDoc = (<Document>
        <Page size="A4" style={styles.page} >
            <View fixed style={{margin:'10 10 0 10', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                <Text style={{fontSize:'10'}}>For Extra Copies Only</Text>
                <Text style={{fontSize:'10'}} render={({ pageNumber, totalPages }) => (
                    `Page No: ${pageNumber} / ${totalPages}`
                    )} fixed />            
            </View>
            <View fixed style={{margin:'20 10 0 20', display:'flex', justifyContent:'space-between'}}>
                <View style={styles.section}>
                    <Text style={{fontSize:'14',fontWeight:'bold', margin:'auto'}}>VARDHMAN MAHAVEER OPEN UNIVERSITY, KOTA</Text>
                    <Text style={{fontSize:'12',fontWeight:'bold', paddingTop:'6', margin:'auto'}}>{'AWARD LIST FOR EXAM ' + po.exam}</Text>
                </View>    
                <View style={{margin:'20 10 10 20', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                <Text style={{fontSize:'10'}} className="ml-4">Batch : <span style={{fontSize:'10',fontWeight:'bold'}}>{po.batchcode}</span></Text>
                    <Text style={{fontSize:'10'}} className="ml-4">Course : <span style={{fontSize:'10',fontWeight:'bold'}}>{po.ccode}</span></Text>
                    <Text style={{fontSize:'10'}} className="ml-4">Max Marks : ______</Text>
                </View>
            </View>
            <View fixed style={{ margin:'0 10 0 20', display:'flex', flexDirection:'row', justifyContent:'space-between',   borderWidth:'1px'}}>
                <Text style={{width:'5%',textAlign:'center', fontSize:'12'}}>S.No</Text>
                <Text style={{width:'20%',textAlign:'center', fontSize:'12',borderLeftWidth:'1px'}}>Sch. No</Text>
                <Text style={{width:'20%',textAlign:'center',fontSize:'12',borderLeftWidth:'1px'}}>{'Marks Obt'}</Text>
                <Text style={{width:'45%',textAlign:'center', fontSize:'12',borderLeftWidth:'1px'}}>{'Marks Obt(In Words)'}</Text>
            </View>
            {marks.map((i,k) => (
                <View wrap={false} key={k} style={{height:'20px', margin:'0 10 0 20', display:'flex', flexDirection:'row', justifyContent:'space-between', borderBottomWidth:'1px', borderRightWidth:'1px',  borderLeftWidth:'1px'}}>
                    <Text style={{width:'5%',textAlign:'center',  fontSize:'10'}}>{k+1}</Text>
                    <Text style={{width:'20%',textAlign:'center',  fontSize:'10',borderLeftWidth:'1px'}}>{}</Text>
                    <Text style={{width:'20%',textAlign:'center', fontSize:'10',borderLeftWidth:'1px'}}>{}</Text>
                    <Text style={{width:'45%',textAlign:'center', fontSize:'10',borderLeftWidth:'1px'}}>{}</Text>
                </View>
            ))}
            <View fixed style={{margin:'0 10 30 20', height:'60px', display:'flex', flexDirection:'row', alignItems:'flex-end', justifyContent:'space-between'}}>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>{'Examiner : '}</Text>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>{'Date : '}</Text>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>Signature</Text>
                </View>
        </Page>
    </Document>);
    }
    return (
        <PDFViewer style={{height:'100vh'}} width="100%" showToolbar={true}>
            {pdfDoc}
        </PDFViewer>
    );
};

const mapStateToProps = state => {
    return {
        username:state.auth.username,
        userid:state.auth.userid,
        email:state.auth.email,
        isAuth:state.auth.token!==null,
    }
}

export default connect(mapStateToProps)(Awlblank);